export enum OENActionButtonProperty {
  LOCKING,
  VISIBILITY,
}
